import { render, staticRenderFns } from "./AuditorSeatAssign.vue?vue&type=template&id=1fccdfba&scoped=true"
import script from "./AuditorSeatAssign.vue?vue&type=script&lang=js"
export * from "./AuditorSeatAssign.vue?vue&type=script&lang=js"
import style0 from "./AuditorSeatAssign.vue?vue&type=style&index=0&id=1fccdfba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fccdfba",
  null
  
)

export default component.exports